<template>
    <div 
        class="message-state d-flex flex-column mt-4"
        style="height: 305px">
        <div :class="{'error-state': emptyMessage}">
            <p class="mb-2 lab c6">{{label || 'Message'}}*</p>
            <textarea
                id="no-spots-message-input-chatroom"
                class="w-100 lab c6"
                v-model.trim = "message"
            />
            <Icon 
                v-if="emptyMessage"
                icon = "warning"
                class-name="warning-icon position-absolute"/>
            <p class="error-state-texts" v-if="errorMessage">{{errorMessage}}</p>
        </div>
        <div class="mt-auto d-flex justify-content-between">
            <button
                id="cancel-button-cp-modal"
                @click="$emit('hideModal')"
                class="unColor_button c1 p1b">
                    Cancel
            </button>
            <button
                class="phiolet_button c16 p1b"
                id="send-button-cp-modal"
                @click="sendMessage">
                    Send
            </button>
        </div>
    </div>
</template>

<script>
import Icon from '../../Theme/Icon'
import {ref, watch, computed} from '@vue/composition-api'
import {useRouter, useErrors, useMessage} from '../../../core/hooks'
import {cpRequestUseCase, chatUseCase} from '../../../core/usecases'
import {ChatService} from '../../../core/services'
import { message as alertMessage } from 'ant-design-vue'
import {useRoom} from '../../../core/hooks'
export default {
    name: 'SendMessage',
    components: {
        Icon
    },
    props: {
        partner: Object,
        owner: Object,
        label: String
    },
    setup(props, context){

        const {message, emptyMessage, errorMessage, validateMessage} = useMessage();
        const { router } = useRouter();
        const errorHandler = useErrors();
        const user = computed(() => context.root.$store.state.user)


        const sendMessage = async () => {
            const {
                owner,
                partner
            } = props;

            validateMessage();

            if (!owner) {
                errorHandler.setError('pick-your-campaign', true)
            }

            if(!owner || emptyMessage.value || errorMessage.value) {
                return;
            }

            context.root.$ga.event('Chat', 'Send Message', `
                SenderUser: ${user.value.email},
                SenderCampaign: ${owner.title},
                ReceiverCampaign: ${partner.title},
                UpdateDateAdded: false,
                Location: Request Modal
            `)

            context.root.$sendMixpanelEvent('Send Message', {
                'Sender User': user.value.email,
                'Sender Campaign': owner.title,
                'Receiver Campaign': partner.title,
                'Update Date Added': false,
                'Message Box Location': 'Request Modal'
            });

            context.root.$incrementMixpanelPeopleProperty('Sent Messages')

            context.emit('hideModal');

            const roomId = await useRoom([partner.id, owner.id])

            if(!roomId.value) {
                alertMessage.error('Something went wrong.', 2)
                return
            }

            alertMessage.success('The message is successfully sent.', 2)

            chatUseCase.sendMessage({
                roomId: roomId.value,
                partnerId: partner.author_id,
                message: message.value,
            })
            // keep the old way
            // router.push(`/mymessages?campaigns=${owner.id}&campaigns=${partner.id}&message=${encodeURIComponent(message.value)}`).catch(() => {})
            cpRequestUseCase.sendRequestEmail(partner.author_id, message.value, owner)
        }

        return {
            message,
            emptyMessage,
            sendMessage,
            errorMessage
        }
    }
}
</script>